"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var form_1 = require("remota-client/component/form");
var button_1 = require("remota-client/component/button");
var util_1 = require("remota-common/util");
var enums_1 = require("remota-client/common/voucher/enums");
var REMOTA_KEYS = [
    "id",
    "code",
    "name",
    "zipCode",
    "address",
    "tel",
    "fax",
    "banks[0].name",
    "banks[0].code",
    "banks[0].branchName",
    "banks[0].branchCode",
    "banks[0].accountType",
    "banks[0].accountNumber",
    "banks[0].accountName",
    util_1.EnumKeys.BILLED_FROM,
    "registrationNumber",
    "other.custom1",
    "other.custom2",
    "other.custom3",
    "other.custom4",
    "other.custom5",
    "other.custom6",
    "other.custom7",
    "other.custom8",
    "other.custom9",
    "other.custom10",
    "other.custom11",
    "other.custom12",
    "other.custom13",
    "other.custom14",
    "other.custom15",
    "other.custom16",
    "other.custom17",
    "other.custom18",
    "other.custom19",
    "other.custom20",
];
var CONCUR_KEYS = [
    "VendorName",
    "TaxID",
    "BuyerAccountNumber",
    "PaymentMethodType",
    "AddressCode",
    "Address1",
    "Address2",
    "Address3",
    "City",
    "State",
    "PostalCode",
    "Approved",
    "Country",
    "Custom1",
    "Custom2",
    "Custom3",
    "Custom4",
    "Custom5",
    "Custom6",
    "Custom7",
    "Custom8",
    "Custom9",
    "Custom10",
    "Custom11",
    "Custom12",
    "Custom13",
    "Custom14",
    "Custom15",
    "Custom16",
    "Custom17",
    "Custom18",
    "Custom19",
    "Custom20",
];
var SEARCH_OPTIONS = [
    { label: "設定無し", value: "" },
    { label: "前方一致", value: "searchType:begins" },
    { label: "後方一致", value: "searchType:ends" },
    { label: "部分一致", value: "searchType:contains" },
];
var Line = function (props) {
    var _a;
    var column = props.column, onChange = props.onChange, onDelete = props.onDelete;
    var handleSelectChange = react_1.default.useCallback(function (e) {
        var _a;
        onChange(__assign(__assign({}, column), (_a = {}, _a[e.target.name] = e.target.value, _a)));
    }, [column, onChange]);
    var handleInputChange = react_1.default.useCallback(function (e) {
        var _a;
        onChange(__assign(__assign({}, column), (_a = {}, _a[e.target.name] = e.target.value, _a)));
    }, [column, onChange]);
    var handleDelete = react_1.default.useCallback(function () {
        onDelete();
    }, [onDelete]);
    var isEnumKey = react_1.default.useMemo(function () { return Object.values(util_1.EnumKeys).some(function (key) { return key === column.remotaKey; }); }, [
        column.remotaKey,
    ]);
    return (react_1.default.createElement(structure_1.FormRowStructure, null,
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "6 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "Remota" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "remotaKey", value: column.remotaKey, onChange: handleSelectChange },
                        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3059\u308B"),
                        REMOTA_KEYS.map(function (key) { return (react_1.default.createElement("option", { key: key }, key)); }))),
                isEnumKey ? (react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "remotaValue", value: column.remotaValue, onChange: handleSelectChange },
                        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3059\u308B"),
                        (0, enums_1.getEnumOptions)(column.remotaKey).map(function (_a) {
                            var text = _a.text, value = _a.value, disabled = _a.disabled;
                            return (react_1.default.createElement("option", { key: value, value: value, disabled: disabled }, text));
                        })))) : null)),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "6 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30B3\u30F3\u30AB\u30FC" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "externalKey", value: column.externalKey, onChange: handleSelectChange },
                        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3059\u308B"),
                        CONCUR_KEYS.map(function (key) { return (react_1.default.createElement("option", { key: key }, key)); }))),
                isEnumKey ? (react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxInput, { name: "externalValue", value: column.externalValue, onChange: handleInputChange }))) : null)),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "6 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u691C\u7D22\u8A2D\u5B9A" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "searchOption", value: (_a = column.searchOption) !== null && _a !== void 0 ? _a : "", onChange: handleSelectChange }, SEARCH_OPTIONS.map(function (op) { return (react_1.default.createElement("option", { key: op.value, value: op.value }, op.label)); }))))),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "2 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u524A\u9664" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(button_1.NormalButton, { onClick: handleDelete }, "\u524A\u9664"))))));
};
exports.Line = Line;
